import './Icon.scss';

import { b2x } from '@b2x/react/src';

export const iconsNames = [
  'play',
  'plus',
  'minus',
  'language',
  'calendar',
  'cart',
  'close',
  'coupon',
  'credit-card',
  'download',
  'error',
  'filter',
  'hidden',
  'info',
  'instagram',
  'light-arrow-left',
  'light-arrow-right',
  'linkedin',
  'logout',
  'menu',
  'order',
  'privacy',
  'settings',
  'shipping',
  'social-facebook',
  'tiktok',
  'visible',
  'wishlist-full',
  'wishlist',
  'youtube',
  'account',
  'account-logged-in',
  'arrow-down',
  'arrow-up',
  'assistance',
] as const;
export type IconName = (typeof iconsNames)[number];

export type IconSize = 10 | 12 | 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 30 | 34 | 36 | 40 | 44 | 48 | 50 | 72;

export interface IconProps extends b2x.IconProps<IconName, IconSize> {}

export const Icon = (props: IconProps) => <b2x.Icon {...props} />;

export const isIconName = (name?: string): name is IconName => b2x.isIconName(iconsNames, name);
